import React from 'react';
import {
	Show,
	SimpleShowLayout,
	TextField,
	DateField,
	SelectField,
	EditButton,
	TopToolbar,
} from 'react-admin';

import { feedbackStatuses } from './constants';
import Responses from './components/Responses';
import ResponseButton from './components/ResponseButton';
import UserProfileField from '../../components/UserProfileField';


const ShowFeedbackActions = ({ data, basePath }) => (
	<TopToolbar>
		<ResponseButton record={data} style={{ marginRight: '1em' }} />
		<EditButton basePath={basePath} record={data} />
	</TopToolbar>
);

const ShowReview = (props) => {
	const { id: reviewId } = props;
	return (
		<Show {...props} title={`Просмотр Feedback ("${reviewId}")`} actions={<ShowFeedbackActions />}>
			<SimpleShowLayout>
				<UserProfileField label="Пользователь" source="user.id" />
				<TextField label="Сообщение" source="message" multiline />
				<DateField label="Отправлено" source="createdAt" showTime />
				<SelectField label="Прочитано" source="status" choices={feedbackStatuses} />
				<TextField label="Просмотр сообщения и ответов" />
				<Responses />
			</SimpleShowLayout>
		</Show>
	);
};

export default ShowReview;
